
import { LazyLoadImage } from 'react-lazy-load-image-component';

import contents from './content.json';
import { Carousel } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

export default function WhyJoinUs(){
    const { t } = useTranslation();
    return(
        <article>
            <section class="what-we-do">
                <div class="container">
                <div class="row">
                    <div class="col">
                    <div class="section-highlight">{t('home.whyjoinus.section_title')}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="section-title">
                            <h4>{t('home.whyjoinus.title')}</h4>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                    <div class="row">
                        <div class="col-12">

                            <Carousel id="carouselWhyJoinUs" interval={3000} fade={true}>
                                {contents.whyjoinus.map((item, i)=>{
                                    return(
                                        <Carousel.Item key={i}>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="row align-centre">
                                                    <div class="col-md-7">
                                                        <div class="content-wrapper">
                                                            <div class="title">{t(`home.whyjoinus.${item.id}.label`)}</div>
                                                            <div class="description">{t(`home.whyjoinus.${item.id}.description`)}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5">
                                                        <div class="image-placeholder">
                                                            <LazyLoadImage src={require(`../../images/${item.id}.svg`)} alt={t(`home.whyjoinus.${item.id}.label`)} width={500} height={500}/>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Carousel.Item>
                                    )
                                })}
                            </Carousel>

                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </section>
        </article>
    )
}